/* MOOOD theme scripts (Bloomistry style) */
(function () {
  'use strict';

  var M = window.MOOOD || {};
  var root = document.documentElement;
  var isRTL = root.getAttribute('dir') === 'rtl';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function formatMoney(cents) {
    var fmt = M.moneyFormat || '{{amount}}';
    var value = cents / 100;
    var two = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var none = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return none;
      if (k === 'amount_with_comma_separator') return two.replace('.', ',');
      return two;
    }).replace(/\.00(?!\d)/, '');
  }
  function escapeHTML(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }

  var toastTimer;
  function toast(msg) {
    var t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-show'); }, 2400);
  }

  /* ---------- Top bar rotator ---------- */
  function initTopbar() {
    var box = $('[data-rotator]'); if (!box) return;
    var msgs = $$('.topbar__msg', box); if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4500);
  }

  /* ---------- Mega menu (touch) ---------- */
  function initMega() {
    var t = $('[data-mega-toggle]'); var m = $('[data-mega]');
    if (!t || !m) return;
    t.addEventListener('click', function () {
      var open = !m.classList.contains('is-open');
      m.classList.toggle('is-open', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nav__item--mega')) { m.classList.remove('is-open'); t.setAttribute('aria-expanded', 'false'); }
    });
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    el.classList.add('is-opening');
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
    document.body.style.overflow = 'hidden';
    if (el.id === 'WishlistDrawer') renderWishlist();
  }
  function closeDrawer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { el.classList.remove('is-opening'); if (!el.classList.contains('drawer--static')) el.hidden = true; }, 400);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  function initDrawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open-drawer]');
      if (opener) {
        e.preventDefault();
        var cur = e.target.closest('.drawer.is-open');
        if (cur) closeDrawer(cur);
        openDrawer(document.getElementById(opener.getAttribute('data-open-drawer')));
        return;
      }
      if (e.target.closest('[data-open-cart]') && $('#CartDrawer')) { e.preventDefault(); openDrawer($('#CartDrawer')); return; }
      var closer = e.target.closest('[data-close-drawer]');
      if (closer) closeDrawer(closer.closest('.drawer'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('.drawer.is-open').forEach(closeDrawer);
      closeSearch();
    });
  }

  /* ---------- Search ---------- */
  var searchTimer, searchCtrl;
  function openSearch() {
    var o = $('#SearchOverlay'); if (!o) return;
    o.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { o.classList.add('is-open'); }); });
    document.body.style.overflow = 'hidden';
    setTimeout(function () { var i = $('#SearchInput'); if (i) i.focus(); }, 250);
  }
  function closeSearch() {
    var o = $('#SearchOverlay'); if (!o || o.hidden) return;
    o.classList.remove('is-open'); document.body.style.overflow = '';
    setTimeout(function () { o.hidden = true; }, 400);
  }
  function initSearch() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-search]')) { e.preventDefault(); openSearch(); }
      if (e.target.closest('[data-close-search]')) closeSearch();
    });
    var input = $('#SearchInput'); if (!input) return;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { $('#SearchResults').innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        if (searchCtrl) searchCtrl.abort();
        searchCtrl = 'AbortController' in window ? new AbortController() : null;
        var qs = '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8', opts = searchCtrl ? { signal: searchCtrl.signal } : {};
        /* Shopify predictive search does not support every locale (e.g. Arabic): fall back to the English endpoint */
        fetch(M.routes.predictive + qs, opts)
          .then(function (r) { return r.ok ? r.json() : fetch('/en/search/suggest' + qs, opts).then(function (r2) { return r2.json(); }).then(function (j) { j.__fromEn = true; return j; }); })
          .then(function (d) {
            if (d.__fromEn && d.resources && d.resources.results && d.resources.results.products) d.resources.results.products.forEach(function (p) { p.url = (M.routes.root || '/') + String(p.url).replace(/^\/en\//, ''); });
            var products = (d.resources && d.resources.results && d.resources.results.products) || [];
            var box = $('#SearchResults');
            if (!products.length) { box.innerHTML = '<p class="muted">' + M.strings.noResults + '</p>'; return; }
            box.innerHTML = '<div class="sr-list">' + products.map(function (p) {
              var price = typeof p.price === 'string' && p.price.indexOf('.') > -1 ? Math.round(parseFloat(p.price) * 100) : parseInt(p.price, 10);
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
              if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
              return '<a class="sr-item" href="' + p.url + '"><span class="sr-item__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span><span>' + escapeHTML(p.title) + '</span><b>' + formatMoney(price) + '</b></a>';
            }).join('') + '</div><a class="btn btn--outline sr-all" href="' + M.routes.search + '?type=product&q=' + encodeURIComponent(q) + '">' + M.strings.viewAll + '</a>';
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ---------- Cart ---------- */
  function updateCount() {
    return fetch(M.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
        el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      });
      return cart;
    });
  }
  function refreshCart(open) {
    return fetch(M.routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer']; if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('#CartDrawer'); var current = $('#CartDrawer');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (open && !wasOpen) openDrawer(current);
        }
      })
      .then(updateCount);
  }
  function flyToCart(img) {
    var target = $('.cart-btn');
    if (!img || !target) return Promise.resolve();
    var a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width) return Promise.resolve();
    var size = Math.min(a.width, a.height, 200);
    var clone = document.createElement('img');
    clone.src = img.currentSrc || img.src; clone.className = 'fly-img';
    clone.style.cssText = 'left:' + (a.left + a.width / 2 - size / 2) + 'px;top:' + (a.top + a.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;';
    document.body.appendChild(clone);
    return new Promise(function (resolve) {
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        clone.style.transform = 'translate(' + ((b.left + b.width / 2) - (a.left + a.width / 2)) + 'px,' + ((b.top + b.height / 2) - (a.top + a.height / 2)) + 'px) scale(.1)';
        clone.style.opacity = '.3';
      }); });
      setTimeout(function () { clone.remove(); resolve(); }, 820);
    });
  }
  function addToCart(formData) {
    return fetch(M.routes.cartAdd + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: formData })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || M.strings.error); return j; }); });
  }
  function initCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-ajax-add]'); if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button');
      var card = form.closest('[data-product-card]');
      var img = card ? card.querySelector('.card__img') : null;
      btn.classList.add('is-loading');
      addToCart(new FormData(form))
        .then(function () { btn.classList.remove('is-loading'); btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1500); return flyToCart(img); })
        .then(function () { toast(M.strings.added); return refreshCart(false); })
        .catch(function (err) { btn.classList.remove('is-loading'); toast(err.message); });
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-change]'); if (!b) return;
      var line = b.closest('[data-line]'); if (!line) return;
      var list = line.closest('.line-items'); if (list) list.classList.add('is-loading');
      fetch(M.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line.getAttribute('data-line'), 10), quantity: parseInt(b.getAttribute('data-qty-change'), 10) })
      }).then(function (r) { return r.json(); })
        .then(function (res) { if (res.status && res.description) toast(res.description); return refreshCart(false); })
        .catch(function () { toast(M.strings.error); refreshCart(false); });
    });
  }

  /* ---------- Wishlist (saved in this browser) ---------- */
  var WKEY = 'moood-wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function setWish(list) { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} syncWish(); }
  function syncWish() {
    var list = getWish();
    $$('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length; el.classList.toggle('is-empty', list.length === 0);
    });
    $$('[data-wishlist-toggle]').forEach(function (b) {
      b.classList.toggle('is-active', list.indexOf(b.getAttribute('data-wishlist-toggle')) > -1);
    });
    var lbl = $('[data-wishlist-count-label]'); if (lbl) lbl.textContent = '(' + list.length + ')';
  }
  function renderWishlist() {
    var box = $('[data-wishlist-list]'); if (!box) return;
    var list = getWish();
    if (!list.length) { box.innerHTML = '<p class="drawer-empty">' + M.strings.wishlistEmpty + '</p>'; return; }
    Promise.all(list.map(function (h) {
      return fetch(M.routes.root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      box.innerHTML = items.filter(Boolean).map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
        var v = p.variants[0];
        var add = (p.variants.length === 1 && v.available)
          ? '<form data-ajax-add><input type="hidden" name="id" value="' + v.id + '"><input type="hidden" name="quantity" value="1"><button class="btn btn--primary btn--sm" type="submit">' + M.strings.addToCart + '</button></form>'
          : '<a class="btn btn--primary btn--sm" href="' + p.url + '">' + M.strings.view + '</a>';
        return '<div class="wish-item">' + (img ? '<img src="' + img + '" alt="">' : '<span></span>') +
          '<div><a class="wish-item__title" href="' + p.url + '">' + escapeHTML(p.title) + '</a><b>' + formatMoney(p.price) + '</b>' +
          '<div class="wish-item__actions">' + add + '<button type="button" data-wishlist-remove="' + p.handle + '">' + M.strings.remove + '</button></div></div></div>';
      }).join('');
    });
  }
  function initWishlist() {
    syncWish();
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-wishlist-toggle]');
      if (t) {
        e.preventDefault();
        var h = t.getAttribute('data-wishlist-toggle'); var list = getWish(); var i = list.indexOf(h);
        if (i > -1) { list.splice(i, 1); toast(M.strings.wishlistRemoved); } else { list.push(h); toast(M.strings.wishlistAdded); }
        setWish(list);
        $$('[data-wishlist-count]').forEach(function (el) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); });
        return;
      }
      var r = e.target.closest('[data-wishlist-remove]');
      if (r) { var l = getWish().filter(function (x) { return x !== r.getAttribute('data-wishlist-remove'); }); setWish(l); renderWishlist(); }
    });
  }

  /* ---------- Carousels & tabs ---------- */
  function initCarousels(scope) {
    $$('[data-carousel]', scope).forEach(function (c) {
      if (c.__init) return; c.__init = true;
      var track = $('[data-track]', c), prev = $('[data-prev]', c), next = $('[data-next]', c);
      if (!track) return;
      function step(dir) { track.scrollBy({ left: track.clientWidth * 0.9 * dir * (isRTL ? -1 : 1), behavior: 'smooth' }); }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var pos = Math.abs(track.scrollLeft);
        if (prev) prev.disabled = pos <= 2;
        if (next) next.disabled = pos >= max;
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  }
  function initTabs() {
    $$('[data-tabs]').forEach(function (wrap) {
      if (wrap.__tabs) return; wrap.__tabs = true;
      wrap.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-tab]'); if (!tab) return;
        var id = tab.getAttribute('data-tab');
        $$('[data-tab]', wrap).forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        $$('[data-panel]', wrap).forEach(function (p) {
          var on = p.getAttribute('data-panel') === id; p.hidden = !on; p.classList.toggle('is-active', on);
          var tpl = on && p.querySelector('template[data-lazy-panel]');
          if (tpl) { p.replaceChild(tpl.content.cloneNode(true), tpl); syncWish(); }
          if (on) { var c = $('[data-carousel]', p); if (c) { c.__init = false; initCarousels(p); } }
        });
      });
    });
  }

  /* ---------- Infinite feed ---------- */
  function withSection(url, id) {
    var u = new URL(url, window.location.origin);
    u.searchParams.delete('section_id'); u.searchParams.set('section_id', id);
    return u.pathname + u.search;
  }
  function initFeed() {
    var feed = $('[data-feed]'); if (!feed) return;
    var grid = $('[data-feed-grid]', feed), sentinel = $('[data-feed-sentinel]', feed), sortSel = $('[data-feed-sort]', feed), countEl = $('[data-feed-count]', feed);
    var marker = $('[data-next-url]', grid);
    var nextUrl = marker ? marker.getAttribute('data-next-url') : null;
    if (marker) marker.remove();
    var baseUrl = feed.getAttribute('data-base-url'), loading = false, token = 0;
    function buildUrl(path) {
      var u = new URL(path, window.location.origin);
      if (sortSel && sortSel.value) u.searchParams.set('sort_by', sortSel.value);
      return u.pathname + u.search;
    }
    function load(url, replace) {
      if (!url || (loading && !replace)) return;
      loading = true; var my = ++token;
      sentinel.classList.add('is-loading'); sentinel.classList.remove('is-done');
      if (replace) grid.classList.add('is-swapping');
      fetch(withSection(url, 'product-grid-feed')).then(function (r) { return r.text(); }).then(function (html) {
        if (my !== token) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var items = tmp.querySelector('[data-feed-items]'), nx = tmp.querySelector('[data-next-url]');
        if (replace) { grid.innerHTML = ''; grid.classList.remove('is-swapping'); }
        if (items) {
          if (replace && countEl && items.getAttribute('data-total-label')) countEl.textContent = items.getAttribute('data-total-label');
          Array.prototype.slice.call(items.children).forEach(function (c) { grid.appendChild(c); });
        }
        nextUrl = nx ? nx.getAttribute('data-next-url') : null;
        loading = false; sentinel.classList.remove('is-loading');
        if (!nextUrl) sentinel.classList.add('is-done');
        syncWish();
      }).catch(function () { loading = false; sentinel.classList.remove('is-loading'); grid.classList.remove('is-swapping'); });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { if (en[0].isIntersecting && nextUrl && !loading) load(nextUrl, false); }, { rootMargin: '700px 0px' }).observe(sentinel);
    }
    window.addEventListener('scroll', function () {
      if (!nextUrl || loading) return;
      if (sentinel.getBoundingClientRect().top < window.innerHeight + 700) load(nextUrl, false);
    }, { passive: true });
    if (!nextUrl) sentinel.classList.add('is-done');
    $$('[data-feed-filter]', feed).forEach(function (chip) {
      chip.addEventListener('click', function () {
        $$('[data-feed-filter]', feed).forEach(function (c) { c.classList.toggle('is-active', c === chip); });
        baseUrl = chip.getAttribute('data-feed-filter');
        load(buildUrl(baseUrl), true);
      });
    });
    if (sortSel) sortSel.addEventListener('change', function () { load(buildUrl(baseUrl), true); });
  }

  /* ---------- Collection page ---------- */
  function initPlp() {
    var sort = $('[data-plp-sort]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page');
      window.location.href = u.toString();
    });
    var form = $('[data-filter-form]');
    if (form) {
      var submit = function () {
        var params = new URLSearchParams();
        new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
        window.location.href = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      };
      form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
      form.addEventListener('change', function (e) { if (e.target.type === 'checkbox' && window.innerWidth > 989) submit(); });
    }
    initInfinite();
  }

  /* Infinite scroll for collection + search pages (no "load more" button) */
  function initInfinite() {
    var wrap = $('[data-plp-more-wrap]'), grid = $('[data-feed-grid]');
    if (!wrap || !grid) return;
    var link = $('[data-plp-more]', wrap), loading = false, io = null;
    function done() { if (io) io.disconnect(); window.removeEventListener('scroll', onScroll); wrap.remove(); }
    function load() {
      if (loading || !link) return;
      loading = true; wrap.classList.add('is-loading');
      fetch(withSection(link.getAttribute('href'), link.getAttribute('data-section-id'))).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var g = tmp.querySelector('[data-feed-grid]');
        if (g) { var frag = document.createDocumentFragment(); Array.prototype.slice.call(g.children).forEach(function (c) { frag.appendChild(c); }); grid.appendChild(frag); }
        var nx = tmp.querySelector('[data-plp-more]');
        loading = false; wrap.classList.remove('is-loading');
        syncWish();
        if (nx) { link.setAttribute('href', nx.getAttribute('href')); check(); } else done();
      }).catch(function () { loading = false; wrap.classList.remove('is-loading'); });
    }
    function check() { if (!loading && wrap.isConnected && wrap.getBoundingClientRect().top < window.innerHeight + 900) load(); }
    function onScroll() { check(); }
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) load(); }, { rootMargin: '900px 0px' });
      io.observe(wrap);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    link.addEventListener('click', function (e) { e.preventDefault(); load(); });
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    var wrap = $('[data-product]'); if (!wrap) return;
    var dataEl = $('[data-product-json]', wrap);
    var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    var form = $('[data-product-form]', wrap), idInput = $('[data-variant-id]', wrap), atc = $('[data-atc]', wrap);
    var priceBox = $('[data-price-box]', wrap), totalEl = $('[data-total]', wrap), qtyInput = $('[data-qty-input]', wrap);
    var main = $('[data-gallery-main]', wrap), thumbs = $$('[data-thumb]', wrap);
    var current = data.variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || data.variants[0];

    function goTo(i) {
      if (!main || !main.children[i]) return;
      main.scrollTo({ left: main.children[i].offsetLeft - main.offsetLeft, behavior: 'smooth' });
    }
    function currentIndex() { return main ? Math.round(Math.abs(main.scrollLeft) / (main.clientWidth || 1)) : 0; }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    var gp = $('[data-gallery-prev]', wrap), gn = $('[data-gallery-next]', wrap);
    if (gp) gp.addEventListener('click', function () { goTo(Math.max(0, currentIndex() - 1)); });
    if (gn) gn.addEventListener('click', function () { goTo(Math.min(main.children.length - 1, currentIndex() + 1)); });
    if (main) main.addEventListener('scroll', function () {
      var i = currentIndex(); thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }, { passive: true });

    function updateTotal() {
      if (!totalEl || !current) return;
      var q = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      totalEl.textContent = formatMoney(current.price * q);
    }
    wrap.addEventListener('click', function (e) {
      var s = e.target.closest('[data-qty-step]'); if (!s || !qtyInput) return;
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(s.getAttribute('data-qty-step'), 10));
      updateTotal();
    });
    if (qtyInput) qtyInput.addEventListener('input', updateTotal);

    function selected() { return $$('.opt', wrap).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    $$('.opt input', wrap).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var opts = selected();
        $$('.opt', wrap).forEach(function (fs, i) { var l = fs.querySelector('[data-option-value]'); if (l) l.textContent = opts[i]; });
        var v = data.variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
        if (!v) { atc.disabled = true; return; }
        current = v; idInput.value = v.id; atc.disabled = !v.available;
        $('.btn__label', atc).textContent = v.available ? M.strings.addToCart : M.strings.soldOut;
        if (priceBox) {
          var html = '<strong>' + formatMoney(v.price) + '</strong>';
          var pct = v.compare > v.price ? Math.floor((v.compare - v.price) * 100 / v.compare) : 0;
          if (pct > 0) html += '<s>' + formatMoney(v.compare) + '</s><span class="pdp__save">' + M.strings.badge.replace('[P]', pct) + '</span>';
          priceBox.innerHTML = html;
          var ys = $('[data-you-save]', wrap);
          if (ys) { ys.hidden = !pct; if (pct) ys.innerHTML = M.strings.youSave.replace('[A]', formatMoney(v.compare - v.price)); }
        }
        var sku = $('[data-sku]', wrap); if (sku) sku.textContent = v.sku || '';
        if (v.media && main) { var sl = main.querySelector('[data-media-id="' + v.media + '"]'); if (sl) goTo(Array.prototype.indexOf.call(main.children, sl)); }
        updateTotal();
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      });
    });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled) return;
      atc.classList.add('is-loading');
      var slide = main ? main.children[currentIndex()] : null;
      var img = slide ? slide.querySelector('img') : null;
      addToCart(new FormData(form))
        .then(function () { atc.classList.remove('is-loading'); atc.classList.add('is-done'); setTimeout(function () { atc.classList.remove('is-done'); }, 1500); return flyToCart(img); })
        .then(function () { toast(M.strings.added); return refreshCart(false); })
        .catch(function (err) { atc.classList.remove('is-loading'); toast(err.message); });
    });
  }

  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url'); if (!url || el.children.length) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; initCarousels(el); syncWish(); } else { el.remove(); }
      });
    });
  }

  function initAccount() {
    var t = $('[data-toggle-recover]'); if (!t) return;
    t.addEventListener('click', function (e) { e.preventDefault(); $('#LoginBox').hidden = true; $('#RecoverBox').hidden = false; });
    if (window.location.hash === '#recover') t.click();
  }

  function init() {
    initTopbar(); initMega(); initDrawers(); initSearch(); initCart(); initWishlist();
    initTabs(); initCarousels(document); initFeed(); initPlp(); initProduct(); initRecommendations(); initAccount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); initTabs(); syncWish(); });
})();